/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLicense } from '@syncfusion/ej2-base';
import * as mapboxgl from 'mapbox-gl';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// mapbox-gl normally bootstraps its worker by stringifying its own already-bundled
// functions into a Blob (via Function.prototype.toString()). Angular's build always
// downlevels async/await project-wide (forceAsyncTransformation, to keep zone.js able
// to monkey-patch it), which breaks that stringify trick — the extracted worker body
// ends up referencing a Babel helper that isn't in scope, so the worker throws
// "_asyncToGenerator is not defined" and no map ever finishes loading its style/tiles.
// Pointing at Mapbox's own prebuilt CSP worker (copied verbatim as a static asset,
// never touched by our Babel pipeline) sidesteps the self-stringify path entirely.
(mapboxgl as any).workerUrl = '/assets/mapbox-gl-csp-worker.js';

// Registering Syncfusion license key
//OLD KEY
//registerLicense('ORg4AjUWIQA/Gnt2VVhhQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkFhXH5ZdHJQRmFYUkE=');
//NEW KEY 
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1dcXRcR2FZV010V0o=');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error('Error bootstrapping application:', err));
